import React from "react";
import Checkbox from "@mui/material/Checkbox";

function CustomCheckbox(props) {
  return (
    <Checkbox
      checked={props.checked}
      onChange={props.handleChange}
      disabled={props.disabled}
      sx={{
        "& .MuiSvgIcon-root": { fontSize: props.size || 36 },
        color: props.unCheckedColor || "#273135",
        "&.Mui-checked": {
          color: props.checkedColor || "var(--button-primary)",
        },
      }}
    />
  );
}

export default CustomCheckbox;
